import { GoogleAuthProvider, onAuthStateChanged, signInWithPopup, signOut } from 'firebase/auth';
import { auth } from './firebase';
import type { Session } from './session';

// 다른 도메인(firebaseapp.com) 리디렉션은 브라우저 저장소 제한 영향을 받으므로 팝업 방식을 쓴다.
const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

export const firebaseSession: Session = {
  onChange: (cb) => onAuthStateChanged(auth, (u) => cb(u ? { email: u.email, displayName: u.displayName } : null)),
  signIn: async () => {
    await signInWithPopup(auth, provider);
  },
  signOut: () => signOut(auth),
  getIdToken: async () => (auth.currentUser ? auth.currentUser.getIdToken() : null),
};
